import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { Button } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/EditOutlined';
import { ChildBase } from '@unicorn/sdui';
import {
  $pending,
  $sduiReadonly,
  setSduiReadonly,
  updateSduiTicket,
} from '../../../../models/detail-sdui';
import { TicketButtonActions } from '../../../../molecules/ticket-button-actions';
import { MessageToApplicant } from '../../../retaled-tickets-tab/message-to-applicant';
import * as Styled from '../../styled';
import { BgrLoader } from '../bgr-loader';

export const ActionsEdit = ({
  valid,
  sduiData,
  openedId,
}: {
  valid: boolean;
  sduiData: ChildBase[];
  openedId: number | string;
}) => {
  const [sduiReadonly, pending] = useUnit([$sduiReadonly, $pending]);

  const containerRef = useRef(null);

  return (
    <>
      <MessageToApplicant />

      <Styled.Actions ref={containerRef}>
        <BgrLoader visible={pending} container={containerRef}></BgrLoader>

        {sduiReadonly ? (
          <ModeView />
        ) : (
          <ModeEdit valid={valid} sduiData={sduiData} openedId={openedId} />
        )}
      </Styled.Actions>
    </>
  );
};

export const ModeView = () => {
  const { t } = useTranslation();

  return (
    <>
      <Styled.ActionsLeft>
        <Button
          onClick={() => setSduiReadonly(false)}
          startIcon={<EditIcon />}
          variant="outlined"
        >
          {t('edit')}
        </Button>

        <TicketButtonActions noBorderRadius={true} isSdui={true} />
      </Styled.ActionsLeft>

      <Styled.ActionsRight></Styled.ActionsRight>
    </>
  );
};

export const ModeEdit = ({
  valid,
  sduiData,
  openedId,
}: {
  valid: boolean;
  sduiData: ChildBase[];
  openedId: number | string;
}) => {
  const { t } = useTranslation();

  return (
    <Styled.ActionsLeft>
      <Button
        disabled={!valid}
        onClick={() => updateSduiTicket({ openedId, sduiData })}
        startIcon={<CheckIcon />}
        variant="contained"
      >
        {t('Save')}
      </Button>

      <Button
        onClick={() => setSduiReadonly(true)}
        variant="outlined"
        startIcon={<CloseIcon />}
      >
        {t('cancel')}
      </Button>
    </Styled.ActionsLeft>
  );
};
